<template>
    <div class="live-income">
        <div class="income-content" v-if="incomeList.length > 0">
            <div class="income-item" v-for="(item, index) in incomeList" :key="index">
                <div class="icome-item-title"> {{ $t('时间：xxx', { time: item.createTime }) }}</div>
                <div class="income-item-content">
                    <div class="income-detail font-bold">
                        <span :class="[language == 'ug' && 'ug']">{{ $t('直播时长') }}</span>
                        <div class="incom-right">
                            <span class="time">{{ getLiveTime(item.createTime,item.updateTime) }}</span>
                            <!-- <img src="@/assets/income-icon.png" alt=""> -->
                        </div>
                    </div>
                    <div class="income-detail font-bold">
                        <span :class="[language == 'ug' && 'ug']">{{ $t('总收益') }}</span>
                        <div class="incom-right">
                            <span class="time">{{ resultSumEarning(item) }}</span>
                            <img src="@/assets/income-icon.png" alt="">
                        </div>
                    </div>
                    <div class="income-detail">
                        <span>{{ $t('礼物收益') }}</span>
                        <div class="incom-right">
                            <span class="time">{{ item.giftEarning }}</span>
                            <img src="@/assets/income-icon.png" alt="">
                        </div>
                    </div>
                    <div class="income-detail">
                        <span>{{ $t('时长收益') }}</span>
                        <div class="incom-right">
                            <span class="time">{{ item.durationEarning }}</span>
                            <img src="@/assets/income-icon.png" alt="">
                        </div>
                    </div>
                    <div class="income-detail" v-if="item.taskEarning">
                        <span>{{ $t('任务收益') }}</span>
                        <div class="incom-right">
                            <span class="time">{{ item.taskEarning }}</span>
                            <img src="@/assets/income-icon.png" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <van-empty v-else class="custom-image" :image="emptyImage" :description="$t('暂时没有直播收益记录')" />
    </div>
</template>

<script>
import { getLiveEarning } from "@/api"
import moment from "moment"
export default {
    data() {
        return {
            language: 'ug',
            incomeList: [],
            emptyImage: require('@/assets/Empty_NoData.png'),
        }
    },
    created() {
        this.language = this.$route.query.language || 'ug'
        this.getLiveEarning()
    },
    methods: {
        getLiveEarning() {
            getLiveEarning({ pageNum: 1, pageSize: 9999 }).then((res) => {
                if (res.code == 1001 && res.data && res.data.list) {
                    this.incomeList = res.data.list
                }
            })
        },
        getLiveTime(start, end) {
            if (start && end) {
                return moment(new Date(end) - new Date(start) - 8 * 3600 * 1000).format('HH:mm:ss')
            }
        },
        resultSumEarning(item) {
            const {giftEarning, durationEarning, taskEarning} = item
            const sum =  Number(giftEarning) * 100 + Number(durationEarning)  * 100 + Number(taskEarning) * 100
            return sum / 100
        }
    }
}
</script>

<style lang="scss" scoped>
.live-income {
    padding: 8px 14px;
    background: #F5F7FA;
    min-height: calc(100vh - 108px);
    box-sizing: border-box;
}

.custom-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

::v-deep .van-empty__image {
    width: 180px;
    height: 160px;
}

::v-deep .van-empty__description {
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    padding: 0;
    font-size: 14px;
    color: #999999;
}

.income-item {
    background: #FFFFFF;
    border-radius: 8px;
    padding: 16px 10px;

    &:not(:last-child) {
        margin-bottom: 8px;
    }

    .icome-item-title {
        font-weight: 400;
        font-size: 14px;
        color: #9B9B9B;
        padding-bottom: 10px;
        border-bottom: 1px solid #F2F2F6;
    }

    .income-item-content {
        padding-top: 10px;
    }

    .income-detail {
        display: flex;
        justify-content: space-between;
        font-weight: 400;
        font-size: 14px;
        color: #5C5C5C;

        .incom-right {
            display: flex;
            align-items: center;

            img {
                width: 16px;
                height: 16px;
            }
        }

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    .font-bold {
        font-weight: 500;
        font-size: 16px;
        color: #181818;
    }
}
</style>